/* eslint-disable react/jsx-no-duplicate-props */
import { useController } from 'react-hook-form';
import ErrorIcon from '@mui/icons-material/Error';
import { toPattern } from 'vanilla-masker';
import { TextField, TextFieldProps } from '@mui/material';
import { Container } from './styles';

type Props = TextFieldProps & {
  errorText?: string;
  mask?: string;
  name: string;
  control: any;
  endAdornment?: React.ReactNode;
  maxLength?: number;
  renderErrorOnRow?: boolean;
  width?: string;
  preventNaN?: boolean;
  onCallSubmit?: () => void;
};
export function ModalInputCode({
  type,
  errorText,
  mask,
  name,
  control,
  endAdornment,
  maxLength,
  renderErrorOnRow,
  width,
  preventNaN,
  onCallSubmit,
  ...props
}: Props) {
  const {
    field: { value, ref, onChange },
  } = useController({
    name,
    control,
  });
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
    props?.onChange?.(e);
  };
  return (
    <Container renderErrorOnRow={renderErrorOnRow} width={width}>
      <div className="divInput">
        <TextField
          className="inputCode"
          type={type ?? 'text'}
          {...props}
          ref={ref}
          onChange={handleOnChange}
          value={mask ? toPattern(value ?? '', mask) : value}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onCallSubmit && onCallSubmit();
              e.preventDefault();
            }
            if (preventNaN) {
              if (
                isNaN(Number(e.key)) &&
                !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.code)
              ) {
                e.preventDefault();
              }
            }
          }}
          inputProps={{
            maxLength,
          }}
          InputProps={{
            endAdornment,
          }}
        />
      </div>
      {errorText && (
        <span className="fieldError">
          <ErrorIcon fontSize="inherit" /> {errorText}{' '}
        </span>
      )}
    </Container>
  );
}
